import { createContext, useContext } from "react";
import {
  type FieldValues,
  useFormContext as useReactHookFormContext,
} from "react-hook-form";

import { type IqfFormContextType } from "./types";

export const IqfFormContext = createContext<IqfFormContextType<any> | null>(
  null,
);

/**
 * Combines the react-hook-form context with IqfFormContext.
 */
export function useFormContext<TFieldValues extends FieldValues>() {
  const context = useContext(IqfFormContext);

  /**
   * Making it partial, because typescript is not able to infer
   * the type when using `watch` or `setValue`.
   *
   * Attribute can be `undefined` when is not set in defaultValues.
   */
  const reactHookFormContext = useReactHookFormContext<Partial<TFieldValues>>();

  if (!context) {
    throw new Error("useFormContext must be used within a FormContext");
  }

  return {
    ...reactHookFormContext,
    ...(context as IqfFormContextType<TFieldValues>),
  };
}
